<template src="./index.html"></template>

<script>
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import { URL, apiCall } from "@/utils/api";
const columns = [
  {
    title: "№",
    width: "5%",
    scopedSlots: { customRender: "number" },
    align: "center",
  },
  {
    title: "Müraciət mətni",
    width: "15%",
    scopedSlots: { customRender: "comptext" },
    align: "center",
  },
  {
    title: "Ünvan",
    scopedSlots: { customRender: "address" },
    width: "13%",
    align: "center",
  },
  {
    title: "",
    scopedSlots: { customRender: "action" },
    width: "5%",
    align: "center",
  },
];
export default {
  name: "TodayProblems",
  props: { dataSource: Array, loading: Boolean },
  components: {
    "detail-modal": DetailModal,
  },
  data() {
    return {
      columns,
      modalVisible: false,
      mylocale: { emptyText: "Məlumat yoxdur" },
      problem: null,
      pagination: { pageSize: 10, current: 1 },
    };
  },
  methods: {
    getDetailed(record) {
      this.problem = record;
      this.modalVisible = true;
    },
    handleModalClose() {
      this.modalVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
